import { createTheme } from "@mui/material";
export const theme = createTheme({
  palette: {
    primary: {
      main: "#1E264A",
      blue: "#0000FF",
    },
    secondary: {
      main: "#C0171A",
    },
  },
});
